@if (coupon$ | async; as coupon) {
    <div class="coupon">
        <div class="container">
            <div class="coupon__holder">
                <a target="_blank" href="{{ getUrl(coupon.code) }}">
                    <img src="{{ coupon.image }}" alt="{{ coupon.title }}" title="{{ coupon.title }}"
                         class="coupon-picture"/>
                    <h1>
                        {{ coupon.title }}
                    </h1>
                    <p [innerHTML]="coupon.description"></p>
                </a>
            </div>
        </div>
    </div>
}
